import { combineReducers } from 'redux'

import arquivosAdvertenciaFornecedor from './arquivosAdvertenciaFornecedor'

export default combineReducers({ arquivosAdvertenciaFornecedor })
